import React, { Component, PropTypes } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Media from 'react-responsive';
import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';
import InlineSVG from 'react-svg-inline';
import styles from '../SearchResults.scss';
import mobileStyles from '../SearchResultsMobile.scss';
import CartComponent from 'src/components/Cart/CartComponent';
import _ from 'lodash';
import Rater from 'react-rater';
import TableSupplier from '../../CartPage/elements/tableElements/TableSupplier';
import stylesTable from './ProductTableStyle.scss';
import SortLabel from 'src/components/SortLabel/SortLabel';
import {getScreenWidth} from 'src/logic/utils';

const isMobileScreenHeight = (parseInt(getScreenWidth()) <= 1024);
const columns = [
  {
    id: 'provider',
    title: 'Поставщик'
  },
  {
    id: 'quantity',
    title: 'Наличие шт.'
  },
  {
    id: 'term',
    title: 'Срок дн.'
  },
  {
    id: 'price',
    title: 'Цена'
  },
  {
    id: 'toBasket',
    title: 'В корзину'
  }
];

export default class ProductTable extends Component {
  constructor(props, context) {
    super(props, context);
    this.searchedArticleCount = 4;
  }

  showMore = (e) => {
    e.preventDefault();
    this.searchedArticleCount = this.searchedArticleCount+4;
    this.forceUpdate();
  };

  limitByPrice = (offers) => {
    const {priceMinValue, priceMaxValue} = this.props;
    if(priceMinValue > 0 && priceMaxValue > 0){
      return offers.filter(offer => offer.price && (+offer.price >= priceMinValue) && (+offer.price <= priceMaxValue));
    }
    else if(priceMinValue > 0 || priceMinValue > priceMaxValue){
      return offers.filter(offer => offer.price && (+offer.price >= priceMinValue));
    }
    else if(priceMaxValue > 0){
      return offers.filter(offer => offer.price && (+offer.price <= priceMaxValue));
    }
    else {
      return offers;
    }
  };

  sortByBestOffer = (offers) => {
    switch(this.props.bestOfferValue){
      case 'дешевые в начале': {
        return _.orderBy(offers, [offer => offer.price], ['asc']);
      }
      case 'самые быстрые в начале': {
        return _.orderBy(offers, [offer => offer.supplier.deliveryTerm], ['asc']);
      }
      case 'с наибольшей вероятностью в начале': {
        return _.orderBy(offers, [offer => offer.supplier.rating], ['desc']);
      }
      default: {
        return offers;
      }
    }
  };

  filterBySupplierName = (offers) => {
    const supplierFilterValues = this.props.supplierFilterValues;
    if (supplierFilterValues && supplierFilterValues.length > 0) {
      return offers.filter(offer => _.find(supplierFilterValues, (filterValue) => filterValue.value === offer.supplier.supplierName));
    }

    return offers;
  };

  render() {
    // TODO: if founded supposedDetails render this with "ничего не найдено, возможно вы имели в виду и список похожих деталей".

    const {foundDetail, inStock} = this.props;
    let foundDetailOffers = this.props.foundDetailOffers;
    if(inStock){
      foundDetailOffers = foundDetailOffers.filter(offer => !(!offer.quantity || offer.quantity <= 0));
    }

    foundDetailOffers = this.limitByPrice(foundDetailOffers);
    foundDetailOffers = this.filterBySupplierName(foundDetailOffers);

    if(!foundDetailOffers || !foundDetailOffers.length ) {
      return <p>Совпадений не найдено</p>;
    }

    //foundDetailOffers = _.orderBy(foundDetailOffers, [offer => offer.supplier.supplierName.toLowerCase()], [isAskSupplier ? 'ask': 'desc']);
    foundDetailOffers = this.sortByBestOffer(foundDetailOffers);

    const tableRows = _.map(_.take(foundDetailOffers, this.searchedArticleCount), ({
      supplier,
      quantity,
      price,
      offerId
    }, i) => (
      <Tr>
        <Td column="Поставщик">
          <TableSupplier SupplierName={supplier.supplierName} Rating={supplier.rating}/>
        </Td>
        <Td column="Наличие шт.">
          { (isMobileScreenHeight) && (quantity!=='Под заказ') ?
            quantity : <label>{!quantity || quantity <= 0 ? 'Под заказ' : quantity.toLocaleString()}</label>
          }
        </Td>
        <Td column="Срок дн.">
          {isMobileScreenHeight?<label>{supplier.deliveryTerms} дн.</label>:supplier.deliveryTerms}
        </Td>
        <Td column="Цена, &#8381;">
          {isMobileScreenHeight?<strong>{price}</strong>:price.toLocaleString()}
        </Td>
        <Td column="">
          <CartComponent
            colored
            offerId={offerId}
            onClick={() => this.props.openToCartPopup(offerId)}
             />
        </Td>
      </Tr>
    ));

    return (
      <div style={isMobileScreenHeight?{marginBottom: '1rem'}:{}}>
        <Table className={stylesTable.table}>
          {tableRows}
        </Table>

        {foundDetailOffers.length > this.searchedArticleCount ? <SortLabel className="m-t-0_5">
          <a className="link" href="#" onClick={this.showMore}>Остальные предложения</a>
        </SortLabel> : null}
      </div>
    );
  }
}

ProductTable.propTypes = {
  openToCartPopup: PropTypes.func
};



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/elements/ProductTable.jsx
 **/